import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  PasswordChangeComponent
} from '@modules/settings/users/profile/actions/password-change/password-change.component';
import { UserFormComponent } from '@modules/settings/users/user-form/user-form.component';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: 'app-profile',
  standalone: true,
  imports: [
    CommonModule,
    PasswordChangeComponent,
    UserFormComponent,
    TranslatePipe,
  ],
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.scss'
})
export class ProfileComponent {
  public breadCrumbItems = [];
  currentComponent = 'info'

  show(val) {
    this.currentComponent = val;
  }
}
